export const getAllPermissionOfUser = (profileUser) => profileUser?.roles?.data
  .map((item) => item.permissions.data)
  .flat()
  .map((item) => item.name).concat(profileUser?.permissions?.data?.map((item) => item.name));
